import type { PageTypes } from "@lib/enums/PageTypes";
import { Logger, LogTag, ServiceType } from "@lib/monitoring/logger";
import { algoliaBrowse, type AlgoliaProduct } from "@lib/wrappers/algolia";

export const getAlgoliaProduct = async (
    sku: string,
    locale: string,
    pageType: PageTypes,
    attributesToRetrieve?: string[]
): Promise<AlgoliaProduct | null> => {
    const hits: AlgoliaProduct[] = [];

    const startTime = performance.now();
    await algoliaBrowse(locale).browseObjects({
        query: sku,
        attributesToRetrieve: attributesToRetrieve,
        batch: (batch: AlgoliaProduct[]) => hits.push(...batch),
    });
    Logger.info(ServiceType.ALGOLIA, `${pageType} Algolia Query`, {
        tag: LogTag.PERFORMANCE,
        duration: performance.now() - startTime,
        pageType: pageType,
    });

    return hits.length > 0 ? hits[0] : null;
};
